import React from 'react';
import PropTypes from 'prop-types';
import IconStat from '../../../02_molecules/IconStat';
import FrayedContainer from '../../../02_molecules/FrayedContainer';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBImpactStats = ({ title = '', contents, behaviorSettings = null, uuid = null }) => (
  <div
    className={`bb ${styles['bb-impact-stats']} ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
    id={uuid}
  >
    <FrayedContainer title={title}>
      <div className={styles['bb-impact-stats__wrapper']}>
        {contents.map((stat, i) => (
          <IconStat
            iconURL={stat.iconURL}
            title={stat.number}
            description={stat.description}
            key={`bb-impact-stat-${i}`}
          />
        ))}
      </div>
    </FrayedContainer>
  </div>
);

BBImpactStats.propTypes = {
  title: PropTypes.string,
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      iconURL: PropTypes.string,
      number: PropTypes.string,
      description: PropTypes.string,
    }),
  ).isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBImpactStats;
